<template>

    <div class="container">
        <!-- <header class="headerCom">
          <img class="back" src="/images/public/back.png" @click="goBack" />
          <slot></slot>
        </header> -->
        <header-com>
          <div class="title-ds">
                评价
            </div>
            <div class="submit" @click="addEvaluate()" v-if="okSub">
                <span>提交</span>
            </div>
        </header-com>
        <!-- <div style="">
          <header class="header">
            <div class="title-ds">
                评价
            </div>
            <div class="submit" @click="addEvaluate()">
                <span>提交</span>
            </div>
        </header>
        </div> -->
        <div style="height:50px;width:100%;"></div>
        <div class="main-panel">
            <div style="margin:20px 0 20px 0" v-for="(item,index) in list" v-bind:key="index">
                <div class="title">
                  <div style="position:absolute">
                      <van-rate
                      class="rate-van"
                      v-model="item.evaluateScore"
                      :size="25"
                      @change="onChange"
                      color="#6DDEDE"
                      void-icon="star"
                      void-color="#eee"
                    />

                    </div>
                    <span class="name">
                        {{item.name}}
                    </span>
                    
                    
                    <!-- <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/start.png" alt="" class="start">
                    <img src="/images/order/nostart.png" alt="" class="start"> -->
                    <span class="start-disc" v-if="item.evaluateScore==1">
                        很差
                    </span>
                    <span class="start-disc" v-if="item.evaluateScore==2">
                        差
                    </span>
                    <span class="start-disc" v-if="item.evaluateScore==3">
                        一般
                    </span>
                    <span class="start-disc" v-if="item.evaluateScore==4">
                        好
                    </span>
                    <span class="start-disc" v-if="item.evaluateScore==5">
                        非常好
                    </span>
                </div>
                <div v-if="item.evaluateScore<4&&item.evaluateScore!=0">
                    <template v-for="(obj,ind) in item.childTagBos">
                      <van-tag  size="medium"  v-bind:key="ind" color="#6DDEDE" v-if="obj.flag" @click="checks(item.id,obj.id)">{{obj.name}}</van-tag>
                      <van-tag  size="medium"  v-bind:key="ind" color="#eeeeee" text-color="#000" v-if="!obj.flag" @click="checks(item.id,obj.id)">{{obj.name}}</van-tag>
                    </template>
                </div>
            </div>
            <van-field
              v-if="okSub"
              v-model="parms.exaluateContent"
              rows="4"
              autosize
              label="留言"
              type="textarea"
              maxlength="200"
              placeholder="请输入留言"
              show-word-limit
            />
            <!-- <textarea name="" id="" cols="30" rows="10" v-model="parms.exaluateContent" placeholder="请填写你遇到的问题，以便我们更好的为您服务" class="bu-disc"> -->
                
            <!-- </textarea> -->
            <span class="text-fuck" v-if="okSub">{{parms.exaluateContent.length}}/200</span>
             <div class="no-name-dfe" v-if="okSub">
               <van-checkbox v-model="parms.anonymous" checked-color='#6DDEDE'>匿名评价</van-checkbox>
            <!-- <span>
                匿名评价
            </span>
            <img src="/images/order/no-name.png" style="width: 10px;height: 10px;position: relative;top: 2px;" alt=""> -->
        </div>
        </div>

        <div class="width:100%;margin-top:50px">
            
        </div>
        <van-dialog v-model="show" @confirm="aconfirm()" @cancel="$router.replace({name:'orderList',params: {type: 3}})" title="" show-cancel-button>
          <div class='tips'>支付成功</div>
          <img src="/images/order/paySuc.png" class='imgs'/>
          <div style="text-align: center;margin: 50px;">是否对诊断服务评价?</div>
        </van-dialog>
    </div>
</template>

<script>
  import orderApi from '@/axios/order'
  import { Toast } from 'vant';

  import publicObj from '@/assets/js/public';
  import QRCode from 'qrcode';
  export default {
    name: 'evaluate',
    components : {

    },
    data () {
      return {
        show:true,
        okSub:false,
        list:[],
        parms:{
          evaluateLinkId:1,
          exaluateContent:'',
          anonymous:false,
          evaluateObjJsonVal:{evaluateObjVal:[]}
        }
      }
    },
    computed: {
     
    },
    created () {
     this.code = this.$route.query.code;
     this.getGetLastOrder()
     this.getDetail()
    },
    watch:{
      list(val){
        console.log(val)
      }
    },
    mounted () {
        
    },
    methods: {   
      onChange(){
        this.okSub = true
        for(let obj of this.list){
          if(obj.evaluateScore==0){
            this.okSub = false
            return
          }
        }
      },
      aconfirm(){
       console.log(6666)
      },
      acencel(){
        console.log(77777)
      },
      getEvaluateParms(){
        let evaluateObjVal = []
        for(let obj of this.list){
          let temp = {
            evaluateScore:obj.evaluateScore,
            evaluateObjId:obj.id,
            evaluateObj:obj.name
          }
          let es = []
          for(let fc of obj.childTagBos){
            if(fc.flag){
              es.push(fc)
            }
          }
          temp.evaluateChildTags = es
          evaluateObjVal.push(temp)
        }
        return evaluateObjVal
      },
      addEvaluate(){
        let parms = this.parms
        parms.evaluateObjJsonVal.evaluateObjVal = this.getEvaluateParms()
        orderApi.addEvaluate(parms).then((res)=>{
          this.$router.push({name:'evaluateSuccess'})
          console.log(res) 
        })
        console.log(parms)
      },
      getGetLastOrder(){
        orderApi.getLastOrder().then((res)=>{
          this.parms.orderCode = res
          console.log(res) 
        })
      },
      checks(itemid,id){
        console.log(itemid,id)
        let lsit = this.list
        this.list = null
        this.list = lsit.map(function(obj){
          if(obj.id ==itemid){
              obj.childTagBos = obj.childTagBos.map(function(t){
                if(t.id==id){
                  t.flag = !t.flag
                }
                return t
              })
          }
          return obj
        })
      },
      getDetail(){
        orderApi.searchTags(1).then((res)=>{
          this.list = res.map(function(obj){
            obj.evaluateScore =0
            obj.childTagBos = obj.childTagBos.map(function(t){
              t.flag = false
              return t
            })
            return obj
          })
          console.log(res)  
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.headerCom {
  background: #fff;
}
.container{
    background-color:rgba(247, 247, 247, 1);
    padding: 0 0 50px 0;
    min-height: 1800px;
}
.header{
    background-color: #fff;
}
.title-ds{
    text-align: center;
    height: 100px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 70px;
}
  .title{
    height: 50px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }
  .submit{
    width: 110px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    background: #6DDEDE;
    border-radius: 4px;
    position: absolute;
    right: 60px;
    top: 24px;
    span{
        color:#fff;
    }
  }
  .main-panel{
      background-color: #fff;
      margin: 24px;
      width: calc(100% - 96px);
      padding:24px;
  }
  .start{
    width: 40px;
    height: 38px; 
    position: relative;
    top: 4px;
    margin:0 10px;
    // vertical-align:middle;
  }
  .name{
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 800;
    color: #1A1A1A;
    margin-right:100px;
  }
  .start-disc{
    float: right;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .start-tag{
    margin:10px 20px;
    padding: 5px 10px;
    height: 40px;
    background: #F5F5F5;
    border-radius: 4px;
  }
  .van-tag{
      padding: 5px 10px;
      margin: 10px 20px;
      // background-color:rgba(245, 245, 245, 1)!important;
      // color: rgba(102, 102, 102, 1)!important;
  }
  .bu-disc{
    width: calc(100% - 40px);
    height: 280px;
    background: #F7F7F7;
    border-radius: 4px;
    padding: 20px;
  }
  .text-fuck{
    font-size: 0.32rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    position: relative;
    left:calc(100% - 90px);
    top:-50px;
  }
.no-name-dfe{
    text-align: right;
    position: relative;
    top: -14px;
    font-size:10px
}
.tips{
  font-size: 60px;
  text-align: center;
  color:#6DDEDE;
  margin-top: 60px;
}
.imgs{
  width: 40%;
  margin-left:30%; 
  margin-top: 20px;
}
.rate-van{
  position: relative;
  top: -10px;
  left: 150px;
}  
</style>
